import $ from "jquery";

const init = () => {
  customPopupClose();
};

const customPopupClose = () => {
  $(document).on("click", ".close-popup", function (event) {
    // eslint-disable-next-line no-undef
    elementorProFrontend.modules.popup.closePopup({}, event);
  });
};

try {
  init();
} catch (error) {
  console.warning(error);
}
